import { render, staticRenderFns } from "./userRoleDetailEHR.vue?vue&type=template&id=65a88b98&"
import script from "./userRoleDetailEHR.vue?vue&type=script&lang=js&"
export * from "./userRoleDetailEHR.vue?vue&type=script&lang=js&"
import style0 from "./userRoleDetailEHR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports